import './selectList.tpl.html';

angular
  .module('shared.selectList', [])
  .directive('sbsfSelectList', directive)
  .controller('SelectListCtrl', ['$scope', controller]);

/**
 * Directive to render select list
 */
function directive() {
  return {
    controller: 'SelectListCtrl',
    templateUrl: 'shared/selectList/selectList.tpl.html',
    restrict: 'E',
    scope: {
      records: '=',
      onRequestedRecordChanged: '=',
      onSelectedRecordsChanged: '=',
      allowRequestRecord: '='
    }
  };
}

/**
 * SelectList directive controller
 *
 * @param {object} $scope
 */
function controller($scope) {
  $scope.filteredRecords = [...$scope.records];
  $scope.selectedRecords = [];

  $scope.toggleRecord = function (record) {
    if ($scope.requestedRecord !== record && $scope.allowRequestRecord) {
      $scope.requestedRecord = record;
      $scope.onRequestedRecordChanged(record);
    }
  };

  $scope.toggleSelection = function ($event, record) {
    $event.stopPropagation();
    if ($scope.isSelected(record)) {
      $scope.selectedRecords.splice(getSelectedRecordIndex(record), 1);
    } else {
      $scope.selectedRecords.push(record);
    }
    $scope.onSelectedRecordsChanged(getSelectedRecordsInfo());
  };

  $scope.toggleSelectionAll = function (record) {
    if ($scope.isSelectedAll(record)) {
      $scope.selectedRecords = [];
    } else {
      $scope.selectedRecords = [...$scope.records];
    }
    $scope.onSelectedRecordsChanged(getSelectedRecordsInfo());
  };

  $scope.isSelected = function (record) {
    return getSelectedRecordIndex(record) >= 0;
  };

  $scope.isSelectedAll = function () {
    return $scope.selectedRecords.length === $scope.records.length;
  };

  $scope.searchTextChanged = _.throttle(
    function () {
      if ($scope.searchText === '') {
        $scope.filteredRecords = [...$scope.records];
        return;
      }
      $scope.filteredRecords = _.filter(
        $scope.records,
        (record) => record.toLowerCase().indexOf($scope.searchText.toLowerCase()) >= 0
      );
    },
    300,
    { leading: false }
  );

  /**
   * Find index of selected record
   * @param record
   */
  function getSelectedRecordIndex(record) {
    return $scope.selectedRecords.indexOf(record);
  }

  /**
   * Prepare selected records object
   */
  function getSelectedRecordsInfo() {
    const selectedAll = $scope.isSelectedAll();
    return {
      selectedAll,
      selectedRecords: [...$scope.selectedRecords]
    };
  }
}
